import axiosInstance from './axiosConfig';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Kullanıcı kayıt fonksiyonu
export const register = async (userData) => {
  try {
    // Kullanıcı adı oluştur (boşluk içermemeli, alfanumerik olmalı)
    const username = userData.username || 
      (userData.name + userData.surname).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    
    // Veri oluştur
    const modifiedData = {
      ...userData,
      username,
      phone_number: userData.phone_number || userData.phone
    };
    
    // Veri temizleme (çift gönderimi engelleme)
    const cleanData = { ...modifiedData };
    
    // phone ve phone_number aynı şey, birini kaldır
    if (cleanData.phone_number && cleanData.phone) {
      delete cleanData.phone;
    }
    
    const response = await axiosInstance.post('/auth/register', cleanData);
    //console.log('Register API raw response:', response);
    return response.data;
  } catch (error) {
    console.error('AuthAPI Register Error:', error);
    
    // 400/401 hataları için özel işleme - sayfa yenilenmesini engelleme
    if (error.response && (error.response.status === 400 || error.response.status === 401)) {
      //console.log('Register API 400/401 error caught to prevent page refresh');
      return {
        success: false,
        message: error.response.data?.message || 'Kayıt başarısız oldu',
        errors: error.response.data?.errors || {},
        error: error,
        status: error.response.status
      };
    }
    
    // Diğer hatalar için normal hata işleme
    if (error.response) {
      //console.log('Error response data:', error.response.data);
      // Sunucudan gelen hata mesajı
      throw {
        ...error.response.data,
        status: error.response.status
      };
    } else if (error.request) {
      // İstek gönderildi ancak cevap alınamadı
      //console.log('No response received:', error.request);
      throw {
        message: 'Sunucudan yanıt alınamadı. Lütfen bağlantınızı kontrol edin.',
        networkError: true
      };
    } else {
      // İstek oluşturulurken bir hata oluştu
      //console.log('Request error:', error.message);
      throw {
        message: error.message || 'Beklenmeyen bir hata oluştu.'
      };
    }
  }
};

// Kullanıcı giriş fonksiyonu
export const login = async (credentials) => {
  try {
    // Email veya username ile giriş desteği - sadece gerekli alanları gönder
    const loginData = {
      password: credentials.password
    };
    
    // Email alanı varsa email olarak gönder
    if (credentials.email) {
      loginData.email = credentials.email;
    }
    
    // Username alanı varsa ve email yoksa username olarak gönder
    if (credentials.username && !credentials.email) {
      loginData.username = credentials.username;
    }
    
    //console.log('Login request data:', loginData);
    
    const response = await axiosInstance.post('/auth/login', loginData);
    
    // Token ve kullanıcı bilgilerini AsyncStorage'a kaydet
    if (response.data.token) {
      await AsyncStorage.setItem('token', response.data.token);
      await AsyncStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    
    // 400/401 hataları için özel işleme - sayfa yenilenmesini engelleme
    if (error.response && (error.response.status === 400 || error.response.status === 401)) {
      //console.log('Login API 400/401 error caught to prevent page refresh');
      return {
        success: false,
        message: error.response.data?.message || 'Giriş başarısız oldu. Lütfen bilgilerinizi kontrol edin.',
        errors: error.response.data?.errors || {},
        error: error,
        status: error.response.status
      };
    }
    
    // Diğer hatalar için normal hata işleme
    if (error.response) {
      //console.log('Error response data:', error.response.data);
      // Sunucudan gelen hata mesajı
      throw {
        ...error.response.data,
        status: error.response.status,
        message: error.response.data?.message || 'Giriş başarısız oldu.'
      };
    } else if (error.request) {
      // İstek gönderildi ancak cevap alınamadı
      //console.log('No response received:', error.request);
      throw {
        message: 'Sunucudan yanıt alınamadı. Lütfen bağlantınızı kontrol edin.',
        networkError: true
      };
    } else {
      // İstek oluşturulurken bir hata oluştu
      //console.log('Request error:', error.message);
      throw {
        message: error.message || 'Beklenmeyen bir hata oluştu.'
      };
    }
  }
};

// Kullanıcı çıkış fonksiyonu
export const logout = async () => {
  try {
    // AsyncStorage'dan token ve kullanıcı bilgilerini sil
    await AsyncStorage.removeItem('token');
    await AsyncStorage.removeItem('user');
    return { success: true };
  } catch (error) {
    throw error;
  }
};

// Mevcut kullanıcı bilgilerini al
export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Kayıtlı kullanıcı bilgilerini AsyncStorage'dan al
export const getStoredUser = async () => {
  try {
    const userJSON = await AsyncStorage.getItem('user');
    return userJSON ? JSON.parse(userJSON) : null;
  } catch (error) {
    throw error;
  }
};
